import React, { useEffect, useState } from "react";
import Dropdown from "../../../reusables/dropdown";
import { Modal } from "react-bootstrap";
import { motion } from "framer-motion";
import {
  animationValues,
  transitionValues,
} from "../../../../utils/pageTransitions";
import InputField from "../../../reusables/input";
import OrderDetails from "../../orders/orderDetails";
import StatusHistoryModal from "../../../modals/statusHistoryModal";
import { get_orders_by_supplier } from "../../../../redux/actions/adminActions";
import { connect } from "react-redux";
import Spinner from "../../../reusables/spinner";
import Pagination from "../../../reusables/pagination";
import {
  order_status,
  periods,
  supplier_order_status,
  user_status,
} from "../../../../utils/options";

function Orders({ accessToken, getOrders, supplier_orders, selected }) {
  const [optionsActive, setOptions] = useState(null);
  const [loading, setLoading] = useState(true);
  const [allOrders, setOrders] = useState(supplier_orders || []);
  const [cancelLoading, setCancelLoading] = useState(false);

  const [orderDetails, setOrder] = useState(false);
  const [selectedOrder, setSelect] = useState([]);
  const token = accessToken;

  let params = {};

  const showStatus = () => {
    setOrder(false);
    setStatus(true);
  };

  useEffect(() => {
    setLoading(true);
    getOrders({ token, selected, success });
  }, [selected]);

  const success = () => {
    setLoading(false);
  };

  useEffect(() => {
    setOrders(supplier_orders);
  }, [supplier_orders]);

  const onPageChange = (page) => {
    setLoading(true);
    params = { ...params, ...{ page: page } };
    getOrders({ token, selected, success, params });
  };

  const handleSelect = (id) => {
    setSelect(id);
    setOrder(true);
  };

  const [selectedTime, setTime] = useState("All dates");
  const handleSelectTime = (Item) => {
    setTime(Item);
    let filter = Item;
    setLoading(true);
    params = { ...params, ...{ filter: Item } };
    getOrders({ token, selected, success, params });
  };

  const [hasFilter, setFilter] = useState(false);
  const [selectedStatus, setStatus] = useState("Status");
  const [filteredOrder, setFilteredOrder] = useState(allOrders);
  const handleFilter = (status) => {
    setStatus(status);
    setLoading(true);
    params = { ...params, ...{ status: status } };
    getOrders({ token, selected, success, params });
  };

  const handleSearch = (e) => {
    setLoading(true);
    let value = e.target.value;
    params = { ...params, ...{ search: value } };
    getOrders({ token, selected, success, params });
  };

  return (
    <motion.div
      initial="out"
      animate="in"
      exit="out"
      variants={animationValues}
      transition={transitionValues}
    >
      <div className="pt-3">
        <div className="spaceBetween">
          <div className="searchHolder">
            <InputField
              placeholder="Search by name, phone number or email"
              icon
              iconClass="ri-search-line"
              onChange={handleSearch}
            />
          </div>

          <div className="alignOnly pt-2">
            <Dropdown value={selectedTime} className="mx-1">
              {periods?.map((item) => (
                <div
                  className="isClickable hoverGreen"
                  onClick={() => handleSelectTime(item)}
                >
                  <p className="sectionText px-3 py-2 mb-0">{item}</p>
                </div>
              ))}
            </Dropdown>
            <Dropdown value={selectedStatus} className="mx-1">
              {/* <div
                className="isClickable hoverGreen"
                onClick={() => {
                  setStatus("All");
                  setFilter(false);
                }}
              >
                <p className="sectionText px-3 py-2 mb-0">All</p>
              </div> */}
              {supplier_order_status?.map((item) => (
                <div
                  className="isClickable hoverGreen"
                  onClick={() => handleFilter(item)}
                >
                  <p className="sectionText px-3 py-2 mb-0">{item}</p>
                </div>
              ))}
            </Dropdown>
          </div>
        </div>

        {loading ? (
          <Spinner big />
        ) : (
          <div className="sectionHeight--mid scrollable--mobile pt-4">
            {allOrders.data.length > 0 ? (
              <table className="table table__custom">
                <thead className="sectionText--small textIsGray table__head pb-2">
                  <tr className="">
                    <th className="">Order ID</th>
                    <th className="vAlign">Date</th>
                    <th className="vAlign">Total Products Cost</th>
                    <th className="vAlign">Total Handling Cost</th>
                    <th className="vAlign">Delivery Cost</th>
                    <th className="vAlign">Sub Total</th>
                    <th className="vAlign">Exch. Rate</th>
                    <th className="vAlign">Status</th>
                    <th className="vAlign">Customer</th>
                    <th className="vAlign">Action</th>
                  </tr>
                </thead>
                <tbody className="">
                  {hasFilter
                    ? filteredOrder?.data.map((order) => (
                        <tr className="hasRadius">
                          <td className="alignOnly pt-3">
                            <input
                              type="checkbox"
                              className="isClickable"
                              name=""
                              id=""
                            />

                            <p className="mb-0  sectionText mx-2">
                              #{order.sub_order_id}
                            </p>
                          </td>

                          <td className="pt-3 vAlign">
                            <p className="mb-0  sectionText">{order.date}</p>
                          </td>

                          <td className="pt-3 vAlign">
                            <p className="mb-0  sectionText">
                              ₦{order.product_cost}
                            </p>
                          </td>

                          <td className="vAlign pt-3">
                            <p className="mb-0 sectionText">
                              ₦{order.handling_cost}
                            </p>
                          </td>

                          <td className="vAlign pt-3 address">
                            <p className="mb-0 sectionText">
                              ₦{order.delivery_cost}
                            </p>
                          </td>

                          <td className="vAlign pt-3">
                            <p className="mb-0  sectionText">
                              ₦{order.sub_total}
                            </p>
                          </td>

                          <td className="vAlign pt-3">
                            <p className="mb-0  sectionText">
                              ₦{order.exchange_rate}
                            </p>
                          </td>

                          <td className="pt-3 vAlign">
                            <p className="mb-0  sectionText">
                              ₦{order.platform_fee}
                            </p>
                          </td>

                          <td className="pt-3 vAlign">
                            <p className="mb-0  sectionText">₦{order.vat}</p>
                          </td>

                          <td className="vAlign pt-3">
                            <p className="mb-0  sectionText">
                              ₦{order.profit_per_order}
                            </p>
                          </td>

                          <td className="vAlign pt-3">
                            <p
                              className={`mb-0 tag ${
                                order.delivery_status == "delivered"
                                  ? "done"
                                  : "pending"
                              }`}
                            >
                              {order.delivery_status}
                            </p>
                          </td>

                          <td className="vAlign pt-3">
                            <p className="mb-0  textIsGreen sectionText">
                              {order.customer}
                            </p>
                          </td>

                          <td className="vAlign pt-3">
                            <i
                              class="ri-more-line isClickable"
                              onClick={
                                optionsActive === order.id
                                  ? () => setOptions(null)
                                  : () => setOptions(order.id)
                              }
                            ></i>

                            {optionsActive === order.id && (
                              <div className="options">
                                <div className="caret"></div>
                                <div className="p-2 textIsBold lAlign sectionText--small">
                                  <div
                                    className="hasBorder--bottom pb-2"
                                    onClick={() => handleSelect(order.id)}
                                  >
                                    Order Details
                                  </div>
                                  <div
                                    className="flex pt-2 pb-2 hasBorder--bottom text-red"
                                    onClick={() => handleCancel(order.id)}
                                  >
                                    Cancel {cancelLoading && <Spinner />}
                                  </div>
                                </div>
                              </div>
                            )}
                          </td>
                        </tr>
                      ))
                    : allOrders?.data?.map((order) => (
                        <tr className="hasRadius">
                          <td className="alignOnly pt-3">
                            <input
                              type="checkbox"
                              className="isClickable"
                              name=""
                              id=""
                            />

                            <p className="mb-0  sectionText mx-2">
                              #{order.sub_order_id}
                            </p>
                          </td>

                          <td className="pt-3 vAlign">
                            <p className="mb-0  sectionText">{order.date}</p>
                          </td>

                          <td className="pt-3 vAlign">
                            <p className="mb-0  sectionText">
                              ₦{order.product_cost}
                            </p>
                          </td>

                          <td className="vAlign pt-3">
                            <p className="mb-0 sectionText">
                              ₦{order.handling_cost}
                            </p>
                          </td>

                          <td className="vAlign pt-3 address">
                            <p className="mb-0 sectionText">
                              ₦{order.delivery_cost}
                            </p>
                          </td>

                          <td className="vAlign pt-3">
                            <p className="mb-0  sectionText">
                              ₦{order.sub_total}
                            </p>
                          </td>

                          <td className="vAlign pt-3">
                            <p className="mb-0  sectionText">
                              ₦{order.exchange_rate}
                            </p>
                          </td>

                          <td className="vAlign pt-3">
                            <p
                              className={`mb-0 capitalize tag ${
                                order.delivery_status == "delivered"
                                  ? "done"
                                  : order.order_status == "declined"
                                  ? "declined"
                                  : order.delivery_status == "dispatched"
                                  ? "dispatched"
                                  : "pending"
                              }`}
                            >
                              {order.delivery_status == "pending"
                                ? order.order_status
                                : order.delivery_status === "accepted"
                                ? "processing"
                                : order.delivery_status}
                            </p>
                          </td>

                          <td className="vAlign pt-3">
                            <p className="mb-0 sectionText">{order.customer}</p>
                          </td>

                          <td className="vAlign pt-3">
                            <i
                              class="ri-more-line isClickable"
                              onClick={
                                optionsActive === order.id
                                  ? () => setOptions(null)
                                  : () => setOptions(order.id)
                              }
                            ></i>

                            {optionsActive === order.id && (
                              <div className="options">
                                <div className="caret"></div>
                                <div className="p-2 textIsBold lAlign sectionText--small">
                                  <div
                                    className="hasBorder--bottom pb-2"
                                    onClick={() => handleSelect(order.id)}
                                  >
                                    Order Details
                                  </div>
                                  {/* <div
                                  className="flex pt-2 pb-2 hasBorder--bottom text-red"
                                  onClick={() => handleCancel(order.id)}
                                >
                                  Cancel {cancelLoading && <Spinner />}
                                </div> */}
                                </div>
                              </div>
                            )}
                          </td>
                        </tr>
                      ))}
                </tbody>
              </table>
            ) : (
              <div className="w-100 center sectionHeight--mid pt-4">
                <h2 className="sectionHead--small textIsBold textIsGreen">
                  No orders found
                </h2>
              </div>
            )}
          </div>
        )}
        <div className="d-flex justify-content-end">
          <Pagination
            onChange={onPageChange}
            page={allOrders?.current_page}
            total={allOrders?.total}
            per_page={allOrders?.per_page}
          />
        </div>
      </div>

      <Modal show={orderDetails} onHide={() => setOrder(false)} centered>
        <div className="sectionHeight--mid py-3">
          <OrderDetails orderID={selectedOrder} allocated />
        </div>
      </Modal>

      {/* <Modal show={orderDetails} onHide={() => setOrder(false)} centered>
        <div className="sectionHeight--mid py-3">
          <OrderDetails next={showStatus} />
        </div>
      </Modal> */}

      {/* <StatusHistoryModal
        show={statusModal}
        handleClose={() => setStatus(false)}
      /> */}
    </motion.div>
  );
}

const mapStateToProps = (state) => ({
  accessToken: state.admin.token,
  supplier_orders: state.admin.supplier_orders,
});

const mapDispatchToProps = (dispatch) => ({
  getOrders: (token, status, success) =>
    dispatch(get_orders_by_supplier(token, status, success)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Orders);
